/* stylelint-disable no-descending-specificity, a11y/media-prefers-reduced-motion */

import { keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import * as colors from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const ListWrapper = styled.div`
  margin-top: ${token('space.250', '20px')};
  padding-bottom: 50px;
  min-width: 650px;
  width: 100%;
  min-height: 400px;
`;

export const Loading = styled.div`
  width: 100%;
  animation: fadein 0.25s ease-out;
  text-align: center !important;
  padding: 100px 0 100px !important;
`;

export const EmptyQuery = styled.div`
  margin: 60px 0;
  text-align: center;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin: ${token('space.100', '8px')} 0;
`;

export const RowWrapper = styled.tr`
  [headers='pipeline'] {
    padding: 7px 10px ${token('space.050', '4px')};
  }
  [headers='branch'],
  [headers='commit'] {
    vertical-align: middle;
  }
  [headers='started'],
  [headers='duration'],
  [headers='status'] {
    color: ${token('color.text', colors.N800)};
    width: 200px;
    vertical-align: middle;
    white-space: nowrap;
    > a {
      text-decoration: none;
    }
  }
  [headers='started'] {
    white-space: nowrap;
  }
  [headers='status'] {
    .PipelineRowStatus {
      position: static;
      margin-right: ${token('space.100', '8px')};
      [class$='status'] {
        flex-direction: row;
      }
    }
  }
  &:hover,
  &:focus {
    background-color: ${token('elevation.surface.raised.hovered', colors.N20)};
    box-shadow: ${token(
      'elevation.shadow.raised',
      `-${token('space.050', '4px')}px 0 0 0 ${colors.N20},
      ${token('space.050', '4px')}px 0 0 0 ${colors.N20}`
    )};
    border-radius: ${token('border.radius', '3px')};
  }
`;

export const AuthorCol = styled.td`
  padding-right: 0 !important;
  width: 1%;
  vertical-align: middle !important;
`;

export const CommitMessage = styled.div`
  padding: 1px 0 0;
  max-width: 420px;
  min-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  & > * {
    display: inline;
  }
`;

export const PipelineLink = styled.div`
  a {
    color: ${token('color.text', colors.N800)};
    font-weight: 500;
  }
`;

export const PipelineInfoText = styled.span`
  color: ${token('color.text.subtlest', colors.N100)};
  font-size: 12px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  display: inline-block;
  white-space: nowrap;
  margin-right: 3px;
`;

export const ScheduledIcon = styled.div`
  color: ${token('color.icon', colors.N60)};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${token('color.icon.subtle', colors.N30)};
  border-radius: 100%;
  width: 34px;
  height: 34px;
`;

export const PipelineInfoLink = styled.a`
  color: ${token('color.text.subtlest', colors.N100)};
  font-size: 12px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
  white-space: nowrap;
  margin-right: 6px;
  &:focus {
    color: ${token('color.text.subtlest', colors.N100)};
  }
  &:first-of-type {
    margin-right: 3px;
  }
  &:last-child {
    margin: 0;
  }
  svg {
    position: relative;
    top: ${token('space.025', '2px')};
  }
`;

const spin = keyframes({
  to: {
    transform: 'translateY(-6em)',
  },
});

export const InProgress = styled.span`
  display: inline-block;
  overflow: hidden;
  height: 1.3em;
  margin-top: -0.3em;
  line-height: 1.5em;
  vertical-align: text-bottom;
  &::after {
    display: inline-table;
    white-space: pre;
    text-align: left;
    content: '\\A.\\A..\\A...';
    animation: ${spin} 2s steps(4) infinite;
  }
`;
